// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c {
  height: 100vh;
  position: relative;
}


.sofa{mix-blend-mode:multiply}
.c-wrapper {
  padding: 50px;
  display: flex;
}

.c-left {
  flex: 1 1;
}

.c-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}






form {
  margin-top: 20px;
}

#dark input , textarea { background-color: #ffffff!important}
input {
  width: 100%;
  height: 50px;
  border: none;
  border: 1px solid black;
  margin: 27px 1px;
  font-size: 14px;
  padding-left: 10px;

}

textarea {
  width: 100%;
  margin: 10px 0px;
  font-size: 14px;
  padding-left: 10px;
}

button {
  border: none;
  padding: 15px;
  background-color: #000000;
  color: white;
  font-weight: 500;
  cursor: pointer;
}

@media screen and (max-width: 985px) {
  .sofa {
   
    width: 55vw;
}
  .c-wrapper {
    padding: 50px;
    display: flex;
    flex-direction: column;
  } 
}


@media screen and (max-width: 480px) {
  .c-wrapper {
    flex-direction: column;
    padding: 0px 50px;
  }

 


  form {
    margin-top: 0px;
    display: flex;
    flex-wrap: wrap;
  }

  input {
    width: 35%;
    height: 40px;
    margin: 10px;
    margin-left: 0;
  }

  button {
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contact/contact.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;;AAGA,MAAM,uBAAuB;AAC7B;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;;;;;;AAOA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB,mCAAmC;AAC5D;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;IAEE,WAAW;AACf;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;AACF;;;AAGA;EACE;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;;;;EAKA;IACE,eAAe;IACf,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".c {\n  height: 100vh;\n  position: relative;\n}\n\n\n.sofa{mix-blend-mode:multiply}\n.c-wrapper {\n  padding: 50px;\n  display: flex;\n}\n\n.c-left {\n  flex: 1;\n}\n\n.c-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n\n\n\n\n\nform {\n  margin-top: 20px;\n}\n\n#dark input , textarea { background-color: #ffffff!important}\ninput {\n  width: 100%;\n  height: 50px;\n  border: none;\n  border: 1px solid black;\n  margin: 27px 1px;\n  font-size: 14px;\n  padding-left: 10px;\n\n}\n\ntextarea {\n  width: 100%;\n  margin: 10px 0px;\n  font-size: 14px;\n  padding-left: 10px;\n}\n\nbutton {\n  border: none;\n  padding: 15px;\n  background-color: #000000;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 985px) {\n  .sofa {\n   \n    width: 55vw;\n}\n  .c-wrapper {\n    padding: 50px;\n    display: flex;\n    flex-direction: column;\n  } \n}\n\n\n@media screen and (max-width: 480px) {\n  .c-wrapper {\n    flex-direction: column;\n    padding: 0px 50px;\n  }\n\n \n\n\n  form {\n    margin-top: 0px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  input {\n    width: 35%;\n    height: 40px;\n    margin: 10px;\n    margin-left: 0;\n  }\n\n  button {\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
